import { createSlice } from '@reduxjs/toolkit';

export interface RealtimeState {
  realtimeData: any;
}

const initialState: RealtimeState = {
  realtimeData: {},
};

const realtimeSlice = createSlice({
  name: 'realtime',
  initialState,
  reducers: {
    updateRealtime: (state, action) => {
      state.realtimeData = { ...action.payload };
    },
    resetRealtime: (state) => {
      state.realtimeData = initialState.realtimeData;
    },
  },
});

export const { updateRealtime, resetRealtime } = realtimeSlice.actions;

export default realtimeSlice.reducer;
